/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Local storage API services
  Date: April 2020
**/

const LocalStorageService = (function () {
    let _service;
    function _getService() {
      if (!_service) {
        _service = this;
        return _service;
      }
      return _service;
    }
    
  
    function _setBrandingInfo(obj) {
      localStorage.setItem('brandingInfo', obj);
    }
    
    function _getBrandingInfo() {
      return localStorage.getItem('brandingInfo');
    }
    
    return {
        getService: _getService,
        setBrandingInfo: _setBrandingInfo,
        getBrandingInfo: _getBrandingInfo
    };
  })();
  export default LocalStorageService;
  